module.exports = __webpack_public_path__ + "static/media/brush_13.3e1eec8f.png";